export default "__VITE_ASSET__DpnFI2Bf__"